export const metadataNameHackOut = (name: string) => {
	// assetId -> objectId ¯\_(ツ)_/¯
	if (name === 'assetId') return 'objectId';
	return name;
};

export default metadataNameHackOut;
